import React from 'react';

import Inner from '../components/inner/Inner.tsx';
import Main from '../components/main/Main.tsx';

import I from '../types.ts';

const renderPage: I['renderPage'] = function ({ item, prop: id }) {
    return (
        <div className={`public__innerPage ${item.name === 'main' ? '_blogMain' : '_blogInner'}`}>
            {item.name === 'main' && (
                <>
                    <Main sections={this.sections} setPagesKey={this.setPagesKey.bind(this)} />
                </>
            )}
            {item.name === 'inner' && (
                <>
                    <Inner id={id} setPagesKey={this.setPagesKey.bind(this)} />
                </>
            )}
        </div>
    );
};

export default renderPage;
